import { CatIconZoomIn } from 'blocks-nextjs/blocks-react/components/Icons/ZoomIn';
import { CatIconZoomOut } from 'blocks-nextjs/blocks-react/components/Icons/ZoomOut';
import { isValidZoom } from './utils';
import styles from './zoom-buttons.module.scss';
import cx from 'classnames';

type ZoomButtonsProps = {
  handleZoom: (zoom: number) => void;
  zoom: number;
};

const ZoomButtons = ({ handleZoom, zoom }: ZoomButtonsProps) => {
  const isZoomOutDisabled = !isValidZoom(zoom - 1);
  const isZoomInDisabled = !isValidZoom(zoom + 1);
  return (
    <div className="row z-index-2 end-0 bottom-0 position-absolute me-2 mb-3">
      <div className="d-flex flex-row">
        <button
          type="button"
          className={cx('me-3', styles['zoom-button'], {
            [styles['zoom-button--disabled']]: isZoomOutDisabled
          })}
          onClick={() => handleZoom(zoom - 1)}
          disabled={isZoomOutDisabled}
          data-testid="zoomOutButton"
        >
          <CatIconZoomOut slot="before" />
        </button>
        <button
          type="button"
          className={cx(styles['zoom-button'], {
            [styles['zoom-button--disabled']]: isZoomInDisabled
          })}
          onClick={() => handleZoom(zoom + 1)}
          disabled={isZoomInDisabled}
          data-testid="zoomInButton"
        >
          <CatIconZoomIn slot="before" />
        </button>
      </div>
    </div>
  );
};

export default ZoomButtons;
